
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import HeaderSearch from "./HeaderSearch.vue";
import HeaderButtons from "./HeaderButtons.vue";
import imageService from "@/services/ImageService";

const AppbarStore = namespace("Appbar");
const AppConfigStore = namespace("AppConfig");
const AuthStore = namespace("Auth");

@Component({
  name: "MainHeader",
  components: {
    HeaderSearch,
    HeaderButtons,
  },
})
export default class MainHeader extends Vue {
  searchText = "";

  @AppbarStore.Getter
  private getAppbarStatus!: any;

  @AppConfigStore.Getter
  private getListaPaginasCustom!: any;

  @AppConfigStore.Getter
  private getConfigsVisuais!: any;

  @AuthStore.Getter
  private isLoggedIn!: boolean;

  @AuthStore.Getter
  private isUserAdmin!: boolean;

  linksPaginas = [
    {
      descricao: "Início",
      link: "/home",
    },

    {
      descricao: "Produtos",
      link: "/produtos",
    },
  ];

  adminLinks = [
    {
      descricao: "Administrar",
      link: "/administrar",
    },
  ];

  get mobileViewport() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get getLogoImageUrl() {
    return imageService.makeLogoImageURL(this.getConfigsVisuais.imagemLogo).img;
  }
  openDrawer() {
    this.getAppbarStatus.drawer = !this.getAppbarStatus.drawer;
  }

  navigateTo(link: string) {
    if (
      this.$router.currentRoute.path !== link ||
      Object.keys(this.$router.currentRoute.query).length
    ) {
      this.$router.push(link);
    }
  }

  navigateToCustom(pageName: string) {
    const parsedPageName = pageName.replaceAll(" ", "_").toLowerCase();
    if (this.$router.currentRoute.path !== `/paginas/${parsedPageName}`) {
      this.$router.push({
        name: "PaginaCustom",
        params: {
          name: parsedPageName,
        },
      });
    }
  }
}
